import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=347f4efe&scoped=true"
import script from "./Testimonial.vue?vue&type=script&lang=ts"
export * from "./Testimonial.vue?vue&type=script&lang=ts"
import style0 from "./Testimonial.vue?vue&type=style&index=0&id=347f4efe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347f4efe",
  null
  
)

export default component.exports